import validateDevotion from "./bundleValidator.mjs";

const authority = "https://api.bioydata.com";

export default function () {
    return {
        dontExpectAudio: ["fr", "th"],
        scanErrors: [],
        edition: "",
        daysStatus: [],
        serverStatus: "loading",
        isScanningEdition: false,
        scanWasRun: false,
        selectedDay: 1,
        locale: "",
        editions: [],
        endpointStatuses: { ...allLoading },

        init(locale, editions) {
            this.locale = locale;
            this.editions = editions;
            var now = new Date();
            var start = new Date(now.getFullYear(), 0, 0);
            var diff = now - start;
            var oneDay = 1000 * 60 * 60 * 24;
            this.selectedDay = Math.floor(diff / oneDay);
            this.checkServerStatus();
            this.checkEndpoints();
            setInterval(this.checkServerStatus, 15000);
        },

        selectDay(item) {
            this.selectedDay = item["day"];
            this.checkEndpoints();
        },

        dayStyle(index) {
            const day = this.daysStatus.find((e) => e.day == index);

            const selectDecoration =
                index == this.selectedDay ? "ring-4 ring-today" : "";

            if (day.status == "fail") {
                return "bg-red-500";
            }

            if (day.status == "published") {
                return ["status__button__published", selectDecoration].join(
                    " "
                );
            }

            if (day.status == "pass") {
                return ["status__button__published", selectDecoration].join(
                    " "
                );
            }

            if (day.status == "scanning") {
                return "bg-gray-400";
            }

            if (day.status == "draft") {
                return ["status__button__draft", selectDecoration].join(" ");
            }
            if (day.status == "pending") {
                return ["status__button__pending", selectDecoration].join(" ");
            }
            return ["status__button__empty", selectDecoration].join(" ");
        },

        scanButtonLabel() {
            return this.isScanningEdition
                ? "Abort scan"
                : "Run Deep Scan on Published devotions";
        },

        checkServerStatus() {
            fetch(`${authority}/status`)
                .then((response) => {
                    if (response && response.ok) {
                        this.serverStatus = "pass";
                    } else {
                        this.serverStatus = "fail";
                    }
                })
                .catch((error) => {
                    this.serverStatus = "fail";
                });
        },

        async getDaysStatus(edition) {
            this.scanWasRun = false;
            this.edition = edition;
            const response = await fetch(`/days/${edition}`, {
                credentials: "include",
            });
            const data = await response.json();

            this.daysStatus = data["data"];
            this.scanErrors.length = 0;
            if (data["duplicates"]) {
                this.scanErrors.push(
                    `These days have duplicate entries: ${data["duplicates"]}`
                );
            }
        },

        async checkEndpoints() {
            if (!this.editions) return;
            this.scanErrors.length = 0;
            for (const edition of this.editions) {
                for (
                    var index = 0;
                    index < this.endpointStatuses[edition].length;
                    index++
                ) {
                    await sleep(100);
                    await this.checkEndpointStatus(edition, index);
                }
            }
        },

        async checkEndpointStatus(edition, index) {
            let day = this.selectedDay + index;
            if (day > 365) day = day - 365;
            this.endpointStatuses[edition][index] = "loading";

            try {
                await this.deepScan(edition, day);
                this.endpointStatuses[edition][index] = "pass";
            } catch (error) {
                this.endpointStatuses[edition][index] = "fail";
                this.scanErrors.push(`${edition} day ${day}: ${error}`);
            }
        },

        async deepScanEdition() {
            this.isScanningEdition = !this.isScanningEdition;
            if (this.isScanningEdition) {
                await this.getDaysStatus(this.edition);
            }
            this.scanWasRun = true;

            for (let i = 0; i < 366; i++) {
                this.setStatus(i, "scanning");
            }

            let url = `${authority}/api/v2/devotion/from/1/to/365?locale=${this.locale}&variant=${this.edition}`;
            while (url && this.isScanningEdition) {
                url = await this.scanPage(url);
                await sleep(500);
            }

            this.isScanningEdition = false;
        },

        async scanPage(url) {
            let response;
            try {
                response = await fetch(url);
            } catch (error) {
                return null;
            }

            if (!response || !response.ok) return null;

            // is the response well-formed?
            let data;
            try {
                data = await response.json();
            } catch (error) {
                return null;
            }

            for (const bundle of data["data"]) {
                try {
                    validateDevotion(bundle, this.edition, this.locale);

                    await this.scanAudio(bundle);
                    this.setStatus(bundle["devotionId"], "pass");
                } catch (error) {
                    const day = bundle["devotionId"]
                        ? bundle["devotionId"]
                        : "--";
                    this.setStatus(day, "fail");
                    this.scanErrors.push(`Day ${day}: ${error}`);
                    continue;
                }
            }

            if (data["links"] && data["links"]["next"]) {
                return data["links"]["next"];
            }

            return null;
        },

        setStatus(day, status) {
            const index = this.daysStatus.findIndex((e) => e.day == day);
            if (index == -1) return;
            this.daysStatus[index].status = status;
        },

        async deepScan(edition, day) {
            // do we have a response?
            let response;
            const url = `${authority}/api/v2/devotion/${day}?locale=${this.locale}&variant=${edition}`;
            const link = `<a href="${url}" target="_blank">inspect</a>`;
            try {
                response = await fetch(url);
                if (!response) throw `No response from server. ${link}`;
            } catch (error) {
                throw `Problem connecting with the server ${link}`;
            }

            if (!response.ok)
                throw `Bad response from server: ${response.status}  ${link}`;

            // is the response well-formed?
            let data;
            try {
                data = await response.json();
            } catch (error) {
                console.log(error);
                throw `Response from server is not well formed. ${link}`;
            }

            validateDevotion(data["bundle"], edition, this.locale);

            await this.scanAudio(data["bundle"]);
        },

        async scanAudio(data) {
            if (this.dontExpectAudio.indexOf(this.locale) != -1) return;

            let url;
            try {
                url = data["audio"]["url"];
            } catch (error) {
                throw "Problem with the audio link.";
            }
            const link = `[ <a href="${url}" target="_blank">inspect</a> ]`;
            let response;
            try {
                response = await fetch(url, { method: "HEAD" });
                if (!response) throw `No response from audio link ${link}`;
            } catch (error) {
                throw `Audio link error: ${error} ${link}`;
            }
            if (!response.ok)
                throw `Bad response from audio url: ${response.status} ${link}`;
            if (response.headers.get("content-type") != "audio/mpeg")
                throw `Audio url is not an mp3. ${link}`;
            if (response.headers.get("content-length") < 5000)
                throw `Audio file size looks too small. ${link}`;
        },
    };
}

const allLoading = {
    classic: ["loading", "loading", "loading", "loading", "loading", "loading"],
    express: ["loading", "loading", "loading", "loading", "loading", "loading"],
    youth: ["loading", "loading", "loading", "loading", "loading", "loading"],
};

function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}
